import PageLayout from "@/components/PageLayout";

const AlgemeneLeveringsvoorwaarden = () => (
  <PageLayout
    title="Algemene leveringsvoorwaarden"
    metaDescription="Algemene leveringsvoorwaarden van Magic Print te Rijswijk en Den Haag. Lees onze voorwaarden voor levering, betaling, garantie en meer."
  >
    <h1 className="text-3xl md:text-5xl font-bold mb-6">
      Algemene leveringsvoorwaarden
    </h1>

    <div className="prose prose-neutral dark:prose-invert max-w-none text-muted-foreground">
      <h2>1. Toepasselijkheid van deze voorwaarden</h2>
      <p>1.1 Deze voorwaarden zijn van toepassing op alle aanbiedingen van en op alle overeenkomsten te sluiten tussen Magic Print, onderdeel van Multi Textiles te Rijswijk en Den Haag ("Verkoper") en een wederpartij ("Afnemer") strekkende tot levering van producten ("Producten") en diensten ("Diensten") door Verkoper. Magic Print is de handelsnaam.</p>
      <p>1.2 Aanvullende en afwijkende voorwaarden zijn uitsluitend van kracht indien en voor zover dit uitdrukkelijk en schriftelijk is overeengekomen.</p>

      <h2>2. Totstandkoming van de overeenkomst</h2>
      <p>2.1 Mondelinge aanbiedingen en toezeggingen verbinden Verkoper slechts nadat en voor zover Verkoper deze schriftelijk heeft bevestigd. Alle aanbiedingen van Verkoper zijn vrijblijvend.</p>
      <p>2.2 Orders die mondeling zijn geplaatst dienen, indien dat door Verkoper wordt verlangd, schriftelijk door Afnemer te worden bevestigd.</p>
      <p>2.3 Toezending van aanbiedingen en/of documentatie door Verkoper verplicht ons niet tot acceptatie van een order.</p>

      <h2>3. Prijzen</h2>
      <p>3.1 De prijzen zijn gebaseerd op de soort en de omvang van de te leveren Producten en/of Diensten. De prijzen zijn netto, exclusief verzendkosten en exclusief BTW. Genoemde prijzen zijn exclusief bedrukking, tenzij anders vermeld bij product.</p>
      <p>3.2 Verkoper heeft het recht de overeengekomen prijzen vóór de aflevering te wijzigen in geval van stijgingen van kostprijsfactoren.</p>

      <h2>4. Levering</h2>
      <p>4.1 Het minimum aantal voor zeefdruk is 10 stuks op door Magic Print geleverd textiel, voor borduren bedraagt dit 20 stuks, voor DTF 10 stuks en alle andere technieken 10 stuks.</p>
      <p>4.2 Afnemer is verplicht om de Producten af te nemen op het moment waarop deze aan hem worden geleverd.</p>
      <p>4.4 Magic Print streeft ernaar elke opdracht tussen de 7 en 14 werkdagen te leveren. Door Verkoper opgegeven levertijden zijn nimmer te beschouwen als een fatale termijn, tenzij schriftelijk anders overeengekomen.</p>
      <p>4.8 Opdrachten waarvoor textiel besteld is en waarvoor al werkzaamheden zijn verricht kunnen niet geannuleerd worden.</p>

      <h2>5. Print Producten</h2>
      <p>5.1 Afnemer is verplicht tot het aanleveren van direct reproduceerbaar materiaal van goede kwaliteit.</p>
      <p>5.2 De kleur van de Print Producten kan in werkelijkheid afwijken van de geleverde logo's. We kunnen geen kleurgaranties geven.</p>
      <p>5.7 Verkoper is gerechtigd om 10% meer of minder van het aangegeven aantal Print Producten te leveren.</p>
      <p>5.8 De kleding dient op maximaal 40 graden, binnenstebuiten gewassen te worden. Er mag niet over de bedrukkingen worden gestreken en de kleding mag niet in de wasdroger.</p>

      <h2>6. Textiel Producten</h2>
      <p>6.6 Verkoper is gerechtigd om 5% meer of minder van het aangegeven aantal Textiel Producten te leveren.</p>
      <p>6.8 Standaard afmetingen van de bedrukkingen zijn: borstlogo 10-15 cm, rugbedrukkingen 30×20 cm (A4), tenzij anders overeengekomen.</p>

      <h2>7. Betalingen</h2>
      <p>7.1 Bij het plaatsen van een order gaat de koper akkoord met de betalingsvoorwaarden van Magic Print. Nieuwe klanten: betaling altijd vooraf. Na 10 eerdere bestellingen: 50% vooruit, 50% bij ophalen of aflevering.</p>
      <p>7.6 Bij annulering na akkoord op de opdrachtbevestiging worden 20% annuleringskosten in rekening gebracht.</p>

      <h2>8. Conformiteit</h2>
      <p>8.1 De afgeleverde Producten mogen in gewicht, maat, getal, kleur, concentratie, samenstelling, 5% afwijken van hetgeen is overeengekomen.</p>

      <h2>11. Klachten</h2>
      <p>11.1 De Afnemer dient de Producten bij levering te onderzoeken op gebreken en binnen 2 dagen na ontdekking schriftelijk melding te maken.</p>

      <h2>12. Overmacht</h2>
      <p>12.1 Indien Verkoper niet toerekenbaar tekortschiet (overmacht) is hij niet aansprakelijk. Indien de overmacht langer duurt dan 3 maanden is Verkoper bevoegd de overeenkomst te ontbinden.</p>

      <h2>13. Aansprakelijkheid</h2>
      <p>13.1 De aansprakelijkheid van Verkoper is beperkt tot hetgeen bepaald in artikel 11.3.</p>
      <p>13.2 Verkoper is niet aansprakelijk voor gevolgschade, bedrijfsschade of winstderving.</p>

      <h2>15. Intellectuele eigendomsrechten</h2>
      <p>15.1 De intellectuele eigendom- en auteursrechten in alle software, tekeningen, specificaties en know how berusten bij Verkoper.</p>
      <p>15.2 Films, zeeframen (bij geoffreerde prijs inbegrepen) en borduurkaarten (gratis bij Magic Print) blijven eigendom van Verkoper.</p>

      <h2>17. Diverse bepalingen</h2>
      <p>Magic Print is gevestigd te Den Haag aan de Platinaweg 25, 2544EZ en geregistreerd bij de Kamer van Koophandel te Den Haag onder nummer 53342178.</p>
      <p>Magic Print is telefonisch bereikbaar op werkdagen van 08.30 uur tot 18.00 uur op 070 8873306 of per email op info@magicprint.nl.</p>
    </div>
  </PageLayout>
);

export default AlgemeneLeveringsvoorwaarden;
